<template>
  <div>
    <div>TRTC 测试</div>
    <p class="label">{{ ("Device Select") }}</p>
    <div class="param-container">
      <comp-device-select
        device-type="camera"
        @change="handleValueChange($event, 'cameraId')"
      />
      <comp-device-select
        device-type="microphone"
        @change="handleValueChange($event, 'microphoneId')"
      />
    </div>
    <!-- rtc 房间 -->
    <comp-room
      :sdk-app-id="Number(sdkAppId)"
      :secret-key="secretKey"
      :user-id="userId"
      :room-id="Number(roomId)"
      :camera-id="cameraId"
      :microphone-id="microphoneId"
    />
  </div>
</template>

<script>
// import { clearUrlParam } from "@/utils/utils";
import compDeviceSelect from "@/components/trtc/comp-device-select.vue";
import compRoom from "@/components/trtc/comp-room.vue";

export default {
  components: {
    compDeviceSelect,
    compRoom,
  },
  data() {
    return {
      sdkAppId: 1234,
      secretKey: "123",
      userId: "11",
      roomId: 1232,
      cameraId: "",
      microphoneId: "",
    };
  },
  mounted() {
    clearUrlParam();
  },
  methods: {
    handleValueChange(value, key) {
      this[key] = value;
    },
  },
};
</script>

<style scoped>
</style>
